import { h } from 'preact'
import { BankData } from 'src/assets/scripts/models/market'
import BankOptionsElement from './bank-options-element'
import Savings from './savings-element'
import { CalculatorSavings } from 'models/apps'

interface InteractiveElementsProps {
  banksData: BankData[]
  sellCurrency: string
  buyCurrency: string
  savings: CalculatorSavings
}

const InteractiveElements = ({ banksData, sellCurrency, buyCurrency, savings }: InteractiveElementsProps) => {
  return (
    <div className="hero-form__savings-holder">
      <BankOptionsElement
        banksData={banksData}
        sellCurrency={sellCurrency}
      />
      <Savings
        sellCurrency={sellCurrency}
        buyCurrency={buyCurrency}
        savings={savings}
      />
    </div>
  )
}

export default InteractiveElements
